import React from "react";
import { Link, NavLink, Outlet, useNavigate, useLocation, Navigate } from "react-router-dom";
import { LogOut, LayoutGrid, Image, FilePlus, ArrowUpRight, Link2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  if (user === null) return <div className="min-h-screen bg-[#FDFBF7]" />; // checking
  if (!user || user.role !== "admin") {
    return <Navigate to="/admin/login" state={{ from: loc }} replace />;
  }

  const doLogout = async () => {
    await logout();
    nav("/admin/login", { replace: true });
  };

  return (
    <div data-testid="admin-shell" className="min-h-screen bg-[#FDFBF7] flex">
      {/* Sidebar */}
      <aside className="w-60 bg-stone-950 text-stone-300 flex flex-col sticky top-0 self-start h-screen">
        <Link to="/" className="px-6 py-8 font-serif text-2xl text-white" data-testid="admin-brand">
          Globezing<span className="text-[#9c4122]">.</span>
          <span className="block text-[10px] tracking-[0.3em] uppercase text-stone-500 mt-1">Admin</span>
        </Link>
        <nav className="px-3 flex-1 space-y-1">
          <SideLink to="/admin" end icon={<LayoutGrid size={16} />} label="Posts" testid="nav-admin-posts" />
          <SideLink to="/admin/posts/new" icon={<FilePlus size={16} />} label="New Post" testid="nav-admin-new" />
          <SideLink to="/admin/media" icon={<Image size={16} />} label="Media" testid="nav-admin-media" />
          <SideLink to="/admin/affiliates" icon={<Link2 size={16} />} label="Affiliates" testid="nav-admin-affiliates" />
        </nav>
        <div className="p-4 border-t border-stone-800 text-xs text-stone-400">
          <p className="text-stone-200">{user.name || "Admin"}</p>
          <p className="truncate">{user.email}</p>
          <a href="/" target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1 text-[11px] tracking-widest uppercase hover:text-white">
            View site <ArrowUpRight size={12} />
          </a>
          <button
            onClick={doLogout}
            data-testid="admin-logout-button"
            className="mt-3 inline-flex items-center gap-2 text-[11px] tracking-widest uppercase hover:text-white"
          >
            <LogOut size={13} /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 px-6 sm:px-10 py-10">
        <Outlet />
      </main>
    </div>
  );
}

function SideLink({ to, end, icon, label, testid }) {
  return (
    <NavLink
      to={to}
      end={end}
      data-testid={testid}
      className={({ isActive }) =>
        `flex items-center gap-3 px-3 py-2.5 rounded text-[13px] tracking-wide transition-colors ${
          isActive ? "bg-[#9c4122] text-white" : "text-stone-300 hover:bg-stone-900 hover:text-white"
        }`
      }
    >
      {icon} {label}
    </NavLink>
  );
}
